<template>
  <div class="top_box">
    <div class="big_title">领导班子</div>
    <div class="team_list">
      <div
        class="card_item"
        v-for="(item, index) in teamList"
        :key="'card' + index"
      >
        <img class="card_pix" :src="item.thumbUrl" alt="" />
        <div class="word_box">
          <div class="top_box">
            <div class="name">
              {{ item.title }}<span class="danwei">{{ item.position }}</span>
            </div>
          </div>
          <div
            class="bottom_box"
            v-html="normalizeRichText(item.content)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import api from "@/api/api";
import { normalizeRichText } from "@/utils/richText";
let teamList = ref([]);
let getPageValue = async () => {
  let res = await api.getManageTeamList();
  if (res.code === "0") {
    teamList.value = res.res.data;
  }
};
getPageValue();
</script>
<style lang="less" scoped>
.big_title {
  height: 5.27vh;
  font-weight: 600;
  font-size: 48px;
  line-height: 5.27vh;
  text-align: left;
  font-style: normal;
  color: #333333;
  margin-bottom: 3.38vh;
  font-family: PingFangSC, PingFang SC;
}
.team_list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 2.6vw 3.93vh;
  .card_item {
    display: flex;
    .card_pix {
      width: 11.61vw;
      height: 11.61vw;
      border: 2px solid #006ab1;
      border-radius: 50%;
      margin-right: 2.24vw;
    }
    .word_box {
      flex: 1;
      .top_box {
        padding-bottom: 1.57vh;
        border-bottom: 1px solid #006ab1;
        .name {
          height: 3.3vh;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 1.56vw;
          color: #006ab1;
          line-height: 3.3vh;
          text-align: left;
          font-style: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          .danwei {
            margin-left: 0.78vw;
            height: 25px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 0.94vw;
            color: #333333;
            line-height: 1.97vh;
            text-align: right;
            font-style: normal;
          }
        }
      }
      .bottom_box {
        margin-top: 1.18vh;
        height: 280px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.83vw;
        color: #666666;
        line-height: 2.36vh;
        text-align: justify;
        font-style: normal;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // display: -webkit-box;
        // -webkit-line-clamp: 9;
        // -webkit-box-orient: vertical;
        overflow-y: scroll;
        overflow-x: hidden;
      }
      .bottom_box::-webkit-scrollbar {
        width: 0 !important;
      }
      .bottom_box {
        -ms-overflow-style: none;
      } // IE 10+
      .bottom_box {
        overflow: -moz-scrollbars-none;
      } // Firefox
    }
  }
}
</style>